@if(displayedColumns.length > 0) {

<!-- TOOLBAR -->
<div class="w-full mb-4">
  <!-- <button mat-icon-button (click)="toggleFilters()">
    <mat-icon>{{ showFilter ? 'filter_alt_off' : 'filter_alt' }}</mat-icon>
  </button>

  <span class="spacer"></span>


  <button mat-stroked-button color="primary" (click)="exportCsv()">CSV</button> -->



  <div class="flex flex-wrap justify-between items-center gap-2 w-full">
    <div class="flex flex-wrap justify-start items-center gap-2">
      <ng-template [ngTemplateOutlet]="template!">

      </ng-template>



      <!-- <button id="filterButton" *ngIf="tableOptions?.noApiCalls != true"
        [class]="(showFilter ? 'delete-button' : 'dl-button') + ' transform duration-300 p-2 rounded-xl'"
        (click)="showFilters($event)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
          <path d="M21 21l-6 -6" />
        </svg>

      </button> -->
    </div>


    <!-- <button id="chooserButton" class="p-2 rounded-xl shadow-medium hover:bg-black/10" (click)="showChooser()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z" />
      </svg>

    </button> -->
  </div>

  <div>

  </div>





</div>

<div @slideDownUp [class]="'flex flex-wrap py-2 '" *ngIf="showFilter  && filterTable.length > 0">

  <div *ngFor="let col of filterTable; let i = index">

    <div *ngIf="(col.type=='text'|| col.type == 'barcode') && !col.filterDropdown" class="px-2.5 py-1.5">
      <input [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '" type="search"
        (keyup)="pushFilter($event)" [(ngModel)]="col.filterValue" [placeholder]="col.name">
    </div>
    <div *ngIf="(col.type=='text'|| col.type == 'barcode' || col.type == 'chip') &&  col.filterDropdown"
      class="px-2.5 py-1.5 min-w-72">
      <app-custom-drop-down-list [fieldName]="col.field" [url]="col.dropdownFilterUrl" [placeholder]="col.name"
        (genericChange)="pushFilter($event)" [value]="col.filterValue" [(ngModel)]="col.filterValue"
        [api]="true"></app-custom-drop-down-list>
    </div>
    <div *ngIf="col.type=='date'" class="px-2.5 py-1.5 flex">
      <!-- <app-custom-date-picker  [id]="col.field"  [fieldId]="col.field" [value]="col.filterValue || ''" (changeValue)="pushFilter($event)" (keyUp)="pushFilter($event)"></app-custom-date-picker> -->
      <input #datePicker [id]="col.field" type="date"
        class="e-input rounded-lg {{col.filterValue != '' ? 'rounded-r-none' : '' }}  transform duration-300"
        [(ngModel)]="col.filterValue" (keyup)="pushFilter($event)" (change)="pushFilter($event)">
      <button class="bg-input  rounded-r-lg p-2" *ngIf="col.filterValue != ''"
        (click)="col.filterValue = '';pushFilter($event)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="w-6 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div *ngIf="col.type=='checkbox'" class="px-2.5 py-1.5">
      <div class="e-primary-filtering">
        <p>{{col.name}}</p>
        <input [id]="col.field" type="checkbox" [ngClass]="'rounded-2xl p-2 '" [(ngModel)]="col.filterValue"
          id="{{col.field}}" (change)="pushFilter($event)">

      </div>
    </div>
    <!-- <div *ngIf="col.type=='dropdown'" class="px-2.5" >
                    <input #inputEl [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '"
                    type="text" (keyup)="checkFilters($event)" [placeholder]="col.name" >
                  </div> -->
  </div>
</div>

<!-- 
<div @slideDownUp *ngIf="chooserOpen" class=" card-primary p-2 my-2">
  <p class="text-lg font-bold mb-2 text-colored">Visibilità colonne</p>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-2">


    @for(column of chooserData; track column){

    <div class="flex justify-start items-center gap-2">
      <ejs-checkbox type="checkbox" [checked]="column.visible"
        (checkedChange)="toggleColumnVisibility(column.headerText,$event)"></ejs-checkbox>
      <p>{{column.headerText}}</p>
    </div>

    }
  </div>
</div> -->



<!-- TABLE WRAPPER -->
<div class="table-wrapper mat-elevation-z8">


  <table @fadeInOutWithBlur *ngIf="loading" mat-table [dataSource]="[].constructor(10)" class="mat-table">

    <!-- Single Column -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>
        <div class="w-full text-center text-lg flex justify-center items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
            viewBox="0 0 24 24"><!-- Icon from SVG Spinners by Utkarsh Verma - https://github.com/n3r4zzurr0/svg-spinners/blob/main/LICENSE -->
            <g stroke="currentColor">
              <circle cx="12" cy="12" r="9.5" fill="none" stroke-linecap="round" stroke-width="3">
                <animate attributeName="stroke-dasharray" calcMode="spline" dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite" values="0 150;42 150;42 150;42 150" />
                <animate attributeName="stroke-dashoffset" calcMode="spline" dur="1.5s"
                  keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1"
                  repeatCount="indefinite" values="0;-16;-59;-59" />
              </circle>
              <animateTransform attributeName="transform" dur="2s" repeatCount="indefinite" type="rotate"
                values="0 12 12;360 12 12" />
            </g>
          </svg>
          Caricamento in corso
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="p-0.5 rounded-full bg-elevation animate-pulse w-full">&nbsp;</div>
      </td>
    </ng-container>

    <tr mat-header-row class="bg-elevation rounded-2xl" *matHeaderRowDef="['value']">Caricamento in corso</tr>
    <tr mat-row *matRowDef="let row; columns: ['value'];">

    </tr>

  </table>

  <mat-table @fadeInOutWithBlur class="{{loading? 'hidden' : ''}}" [class.isMobile]="isMobile" (matSortChange)="sortChange($event)"
    [dataSource]="gridDataSource" matSort multiTemplateDataRows>

    <!-- Row‑selection checkbox (opzionale, guidato dal tuo TS) -->
    <ng-container *ngIf="displayedColumns.includes('select')" matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection?.hasValue() && isAllSelected()"
          [indeterminate]="selection?.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection?.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- DINAMIC COLUMNS DEFINITE DAL CONFIG → una sola definizione per ogni voce -->
    <!-- ITERAZIONE 1: Colonne NON-BUTTON -->
    @for (col of gridColConfig; track $index) {
    @if (col.type != 'button') {
    <ng-container [matColumnDef]="col.field">

      <!-- HEADER -->
      @if(col.sort != false){
      <mat-header-cell *matHeaderCellDef [style.text-align]="col.textAlign || 'left'" [mat-sort-header]="col.field">
        {{ col.name }}
      </mat-header-cell>
      }@else{
      <mat-header-cell *matHeaderCellDef [style.text-align]="col.textAlign || 'left'">
        {{ col.name }}
      </mat-header-cell>
      }

      <!-- CELLA -->
      <mat-cell *matCellDef="let row" [style.text-align]="col.textAlign || 'left'">
        <ng-container [ngSwitch]="col.type">
          
          <span class="mobile-label">{{col.name}}: </span>

          <!-- Immagine -->
          <img *ngSwitchCase="'img'" [src]="row[col.field]" class="h-8 w-8 object-cover rounded-lg" />

          <!-- Link esterno/interno -->
          <a *ngSwitchCase="'link'" [href]="col.linkBaseHref ? col.linkBaseHref + row[col.field] : row[col.field]"
            target="_blank" class="text-primary-500 underline">
            {{ row[col.field] }}
          </a>

          <!-- Testo generico -->
          <span *ngSwitchCase="'text'">
            {{ col.textFieldOptions?.prefix || '' }}{{ row[col.field] || col.textFieldOptions?.emptyPlaceHolder || '-'
            }}{{ col.textFieldOptions?.append || '' }}
          </span>
          
          <input *ngSwitchCase="'currency'" [value]="row[col.field]" readonly="true" class="outline-none" [currencyMask]="{allowNegative: false, suffix: ' €',prefix: '', thousands: '.', decimal: ',',align:'left',inputMode:1 }">
            
        

          <!-- Switch -->
          <mat-slide-toggle *ngSwitchCase="'switch'" [(ngModel)]="row[col.field]"
            (change)="switchChange($event, row)"></mat-slide-toggle>

          <!-- Checkbox cella -->
          <mat-checkbox *ngSwitchCase="'checkbox'" [(ngModel)]="row[col.field]"
            (change)="checkBoxChange($event, row)"></mat-checkbox>

          <!-- Colore / SVG -->
          <span *ngSwitchCase="'color'">
            <div *ngIf="row[col.field]?.hex" class="w-8 h-4 rounded" [style.background-color]="row[col.field].hex">
            </div>
            <img *ngIf="row[col.field]?.svg" [src]="'data:image/svg+xml;base64,' + row[col.field].svg"
              class="w-8 h-8" />
          </span>

          <!-- Stato (verde/rosso) -->
          <span *ngSwitchCase="'state'" [ngClass]="row[col.field] ? 'text-green-600' : 'text-red-600'">
            <mat-icon>
              {{ row[col.field] ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </span>

          <!-- Chip -->
          <mat-chip *ngSwitchCase="'chip'" [style.background-color]="row[col.field]?.split('_')[1]">
            {{ row[col.field]?.split('_')[0] }}
          </mat-chip>

          <!-- Data semplice -->
          <span *ngSwitchCase="'date'">{{ row[col.field] | date }}</span>

          <!-- Data + Ora -->
          <span *ngSwitchCase="'dateTime'">{{ row[col.field] | date:'dd/MM/yyyy HH:mm' }}</span>

          <!-- Barcode -->
          <ngx-barcode *ngSwitchCase="'barcode'" [bc-value]="row[col.field]" [bc-format]="'CODE128B'"></ngx-barcode>

          <!-- Valore default -->
          <span *ngSwitchDefault>{{ row[col.field] != null ? row[col.field] : '-' }}</span>
        </ng-container>
      </mat-cell>
    </ng-container>
    }
    }

    <!-- ITERAZIONE 2: Colonna ACTIONS (tutti i button insieme) -->
    <ng-container matColumnDef="actions">

      <!-- HEADER -->
      <mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
      </mat-header-cell>

      <!-- CELLA -->
      <mat-cell *matCellDef="let row" [style.text-align]="'center'">
        <div class="flex gap-2 justify-center">
          @for (col of gridColConfig; track $index) {
          @if (col.type == 'button') {
          <button [matTooltip]="col.name" [ngClass]="col.cssClass" class="p-2 rounded-xl flex justify-center items-center"
            (click)="emitBtnClick(row, col.name.toLowerCase(), col.field.toLowerCase())">
            <i-tabler [name]="col.icon ?? ''" class="w-6 text-current"
              style="width: 1.25rem!important; height:1.25rem!important;"></i-tabler>
            <!--*ngIf="getButtonLabel(col) != undefined"-->
          </button>
          }
          }
        </div>
      </mat-cell>

    </ng-container>




    <ng-container matColumnDef="nodata">
          <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length" 
          style="text-align: center;">Nessun dato disponibile</td>
        </ng-container>

       <tr mat-footer-row 
         [hidden]="gridDataSource.data.length >0"
        *matFooterRowDef="['nodata']">
       </tr>


    <!-- HEADER & DATA ROWS -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"></mat-row>


    
  </mat-table>

  <!-- PAGINAZIONE -->

  <div class="w-full">
    <mat-paginator class="rounded-3xl w-full mt-4" (page)="pageChanged($event)" [length]="totalRows"
      [pageSizeOptions]="[25,50,100]" [hidePageSize]="isMobile" showFirstLastButtons></mat-paginator>
  </div>



</div>



}